// extracted by mini-css-extract-plugin
export default {"container":"website_container__ghxrA","navigate":"website_navigate__9jYIC"};